import { cn } from "@u/cn";

type FieldHintProps = {
  /** Set to wire `aria-describedby` on the input this hint describes. */
  id?: string;
  className?: string;
  children: React.ReactNode;
};

/**
 * Canonical help text under a form field (the descriptive line below an input).
 * Single source for the style — was hand-rolled as `text-xs text-muted-foreground`
 * all over the forms. NOT `text-disclaimer` (that's legal/pricing fine print);
 * this is per-field guidance and can carry an `id` for `aria-describedby`.
 */
export function FieldHint({ id, className, children }: FieldHintProps) {
  return (
    <p
      id={id}
      className={cn("mt-1.5 text-xs leading-relaxed text-muted-foreground", className)}
    >
      {children}
    </p>
  );
}
